import * as helpers from './imports/helpers';

export default class DesignScripts {
    constructor() {
        this.isDesktop = window.matchMedia('(min-width: 1024px)');

        window.classDesignScripts = this;
    }

    importCustomFont(fontFamily) {
        const regular = helpers.newFontFace(fontFamily, 'Regular', 400);
        const bold = helpers.newFontFace(fontFamily, 'Bold', 700);
        const styles = [regular, bold];

        styles.forEach(style => {
            style.load().then(() => {
                document.fonts.add(style);
                document.documentElement.style.setProperty('--font-family ', `${fontFamily}, 'Open Sans', sans-serif`);
            }).catch(error => {
                console.error(error);
            });
        });
    }

    setFontForAllElements(fontFamily) {
        const css = `* { font-family: ${fontFamily}, 'Open Sans', sans-serif;`;
        const head = document.head || document.getElementsByTagName('head')[0];
        const style = document.createElement('style');

        head.appendChild(style);
        style.appendChild(document.createTextNode(css));
    }

    setFontForElement(fontFamily, element) {
        const targets = document.querySelectorAll(`${element}, ${element} *`);

        targets.forEach(target => {
            target.style.fontFamily = `${fontFamily}, 'Open Sans', sans-serif`;
        });
    }

    setFontSizeForElement(element, sizeDT, sizeMB) {
        const target = document.querySelector(`${element}, ${element} *`);

        function setTargetStyle(isDesktop) {
            if (isDesktop.matches) {
                target.style.fontSize = `${sizeDT}px`;
            } else {
                target.style.fontSize = helpers.calcPxToVw(sizeMB);
            }
        }

        setTargetStyle(this.isDesktop);

        this.isDesktop.addEventListener('change', () => {
            setTargetStyle(this.isDesktop);
        });
    }

    setLineHeightForElement(element, sizeDT, sizeMB) {
        const targets = document.querySelectorAll(`${element}, ${element} *`);

        targets.forEach(target => {
            function setTargetStyle(isDesktop) {
                if (isDesktop.matches) {
                    target.style.lineHeight = `${sizeDT}px`;
                } else {
                    target.style.lineHeight = helpers.calcPxToVw(sizeMB);
                }
            }

            setTargetStyle(this.isDesktop);

            this.isDesktop.addEventListener('change', () => {
                setTargetStyle(this.isDesktop);
            });
        });
    }

    setLinearGradient(element, direction, color1, color2) {
        const targets = document.querySelectorAll(element);

        targets.forEach(target => {
            target.style.backgroundImage = `linear-gradient(to ${direction}, ${color1}, ${color2})`;
        });
    }

    setButtonBorderRadius(amount) {
        const _this = this;
        const buttons = document.querySelectorAll('.button');

        function forEachButton() {
            buttons.forEach(button => {
                helpers.setBorderRadius(_this.isDesktop, button, amount);
            });
        }

        forEachButton();

        this.isDesktop.addEventListener('change', () => {
            forEachButton();
        });
    }

    setInputBorderRadius(amount) {
        const _this = this;
        const inputs = document.querySelectorAll('input');
        const selects = document.querySelectorAll('.select');
        const elements = [inputs, selects];

        function forEachElement() {
            elements.forEach(element => {
                element.forEach(input => {
                    helpers.setBorderRadius(_this.isDesktop, input, amount);
                });
            });
        }

        forEachElement();

        this.isDesktop.addEventListener('change', () => {
            forEachElement();
        });
    }

    addVideoBackground(element, url, zIndexElement = 0, zIndexVideo = -1) {
        document.querySelectorAll(element).forEach(element => {
            // Create elements
            const video = document.createElement('video');
            video.muted = true;
            video.autoplay = true;
            video.loop = true;

            const source = document.createElement('source');
            source.setAttribute('src', url);
            video.appendChild(source);

            // Set styling
            video.style.position = 'absolute';
            video.style.top = 0;
            video.style.left = 0;
            video.style.width = '100%';
            video.style.height = '100%';
            video.style.zIndex = zIndexVideo;
            video.style.objectFit = 'cover';
            video.style.objectPosition = 'center';

            // Add elements to page
            const elementPosition = window.getComputedStyle(element).position;
            if (elementPosition !== 'absolute' && elementPosition !== 'relative') {
                element.style.position = 'relative';
            }

            element.style.zIndex = zIndexElement;
            element.style.overflow = 'hidden';
            element.appendChild(video);
        });
    }
}
